import React from "react";
import { dioikProtodikeia as dioikUnfilt } from "../DioikProtodikeia";
import { XCircleIcon } from "@heroicons/react/solid";
import {
  MultiSelect,
  MultiSelectItem,
  Icon,
  List,
  ListItem,
} from "@tremor/react";
import { removeDiacriticsAndCapitalize } from "../../../utils/checkMisthosi";

const ChooseDioik = ({ dioikSelected, setDioikSelected }) => {
  const dioik = dioikUnfilt
    .map((dim) => removeDiacriticsAndCapitalize(dim))
    .sort();
  const handleDeleteListItem = (e) => {
    const value =
      e.target.parentNode.parentNode.parentNode.firstChild.textContent;
    const newDioikSelected = dioikSelected.filter((dim) => dim !== value);
    setDioikSelected(newDioikSelected);
  };

  return (
    <div className="form-group">
      <label htmlFor="dioik">Διοικ.Πρωτοδικεία:</label>
      <MultiSelect
        placeholder="Επιλέξτε Διοικ.Πρωτοδικείο"
        onValueChange={setDioikSelected}
        value={dioikSelected}
      >
        {dioik.map((dim, i) => {
          return (
            <MultiSelectItem key={`${i}-${dim}`} value={dim}>
              {dim}
            </MultiSelectItem>
          );
        })}
      </MultiSelect>
      <List>
        {dioikSelected?.map((dim, i) => {
          return (
            <ListItem className="dimoi-list" key={`${i}-${dim}`}>
              <span>{dim}</span>
              <span>
                <Icon
                  onClick={handleDeleteListItem}
                  className={"cursor-pointer"}
                  icon={XCircleIcon}
                  size={"sm"}
                  color="red"
                  tooltip="Διαγραφή"
                ></Icon>
              </span>
              <ListItem />
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};

export default ChooseDioik;
